import { Injectable } from '@angular/core';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Action, createSelector, Selector, State, StateContext } from '@ngxs/store';
import _ from 'lodash';
import { MobileStatusRemoteDto } from '../../../../../generated/signalR/mobile-status-remote-dto';
import { MobileStatusType } from '../../../../samwebDescription/samweb/contactStatus/mobileStatusType';
import { MobileStatusValuesUpdated } from './mobile-status.actions';

export interface MobileStatusStateModel {
   mobileStates: { [mobileNumber: string]: MobileStatusRemoteDto };
}

@State<MobileStatusStateModel>({
   name: 'mobileStatus',
   defaults: {
      mobileStates: {},
   },
})
@Injectable()
export class MobileStatusState {
   @Selector([MobileStatusState])
   public static getAllAvailableMobileStates(state: MobileStatusStateModel): { [p: string]: MobileStatusRemoteDto } {
      return state.mobileStates;
   }

   private static getMobileStateRawDataSelector(keyValue: string): (allMobileStates: { [p: string]: MobileStatusRemoteDto }) => MobileStatusRemoteDto {
      return createSelector([MobileStatusState.getAllAvailableMobileStates], (allMobileStates: { [p: string]: MobileStatusRemoteDto }) => {
         return allMobileStates[keyValue];
      });
   }

   public static getMobileStateSelector(mobileNumber: string) {
      return createSelector([MobileStatusState.getMobileStateRawDataSelector(mobileNumber)], (mobileState: MobileStatusRemoteDto) => {
         const mobileStatus: any = mobileState ? MobileStatusType.getPresenceStatusByDatabaseValue(mobileState.state) : MobileStatusType.None;
         return {
            mobileState: mobileState,
            mobileStatus: mobileStatus,
         };
      });
   }

   @Action(MobileStatusValuesUpdated)
   @ImmutableContext()
   public contactStatesUpdated(ctx: StateContext<MobileStatusStateModel>, action: MobileStatusValuesUpdated) {
      ctx.setState((state: MobileStatusStateModel) => {
         action.mobileStates.forEach((mobileStatus) => {
            if (_.isNil(mobileStatus.state)) {
               delete state.mobileStates[mobileStatus.mobileNumber];
               return;
            }
            state.mobileStates[mobileStatus.mobileNumber] = mobileStatus;
         });
         return state;
      });
   }
}
